export enum TipoModo {
	PCO = 'Pluviometria',
	PCD = 'Estações automáticas',
}

export enum Formato {
	TABELA = 'Tabela',
	GRAFICO = 'Gráfico',
	MAPA = 'Mapa',
}

export enum TipoGraficoPCD {
	VARIAVEL_METEOROLOGICA = 'Variável meteorológica',
}

export enum TipoMapaPCD {
	VARIAVEL_METEOROLOGICA_ESTACAO = 'Variável meteorológica por estação',
	VARIAVEL_METEOROLOGICA_INTERPOLADA = 'Variável meteorológica interpolada',
	MOSAICO_VARIAVEL_METEOROLOGICA = 'Mosaico de variável meteorológica',
}

export enum TipoTabelaPCD {
	// EVAPOTRANSPIRACAO = 'Evapotranspiração',
	VARIAVEL_METEOROLOGICA = 'Variável meteorológica',
	VALORES_EXTREMOS = 'Valores extremos',
}

export enum TipoGrafico {
	PLUVIOMETRIA_OBSERVADA = 'Pluviometria (mm)',
	NUMERO_DIAS_COM_CHUVA = 'Número de dias com chuva (NDC)',
	CLIMATOLOGIA = 'Climatologia (mm)',
	DESVIO_MILIMETRO = 'Desvio (mm)',
	DESVIO_PORCENTAGEM = 'Desvio (%)',
	IAPM = 'IAPM',
	SPI = 'SPI',
	DESVIO_POR_PERIODO_MM = 'Desvios e totais por períodos (mm)',
	DESVIO_POR_PERIODO_PORCENTAGEM = 'Desvios e totais por períodos (%)',
}

export enum TipoMapa {
	PLUVIOMETRIA_OBSERVADA = 'Pluviometria (mm)',
	PLUVIOMETRIA_INTERPOLADA = 'Pluviometria interpolada',
	MOSAICO_CHUVAS = 'Mosaico de chuvas',
	NUMERO_DIAS_COM_CHUVA = 'Número de dias com chuva (NDC)',
	CLIMATOLOGIA = 'Climatologia (mm)',
	DESVIO_MILIMETRO = 'Desvio (mm)',
	DESVIO_PORCENTAGEM = 'Desvio (%)',
	IAPM = 'IAPM',
}

export enum TipoTabela {
	PLUVIOMETRIA_OBSERVADA = 'Pluviometria (mm)',
	NUMERO_DIAS_COM_CHUVA = 'Número de dias com chuva (NDC)',
	CLIMATOLOGIA = 'Climatologia (mm)',
	DESVIO = 'Desvios',
	IAPM = 'IAPM',
	SPI = 'SPI',
	HISTORICO_DA_SUDENE = 'Histórico da SUDENE',
	PRECIPITACAO_DIARIA = 'Pluviometria diária personalizada',
	PRECIPITACAO_MENSAL = 'Pluviometria mensal personalizada',
	//PRECIPITACAO_ACUMULADA = 'Pluviometria observada anual',
	PRECIPITACAO_ANUAL = 'Pluviometria anual personalizada',
	ESTATISTICA_MENSAL = 'Estatística mensal',
	//DESVIOS_MENSAIS_ANUAIS = 'Totais e desvios mensais e anuais',
	VALORES_EXTREMOS_PLUVIOMETRIA = 'Valores extremos de pluviometria',
	DESVIO_POR_PERIODO = 'Acumulados e desvios por período',
}

export enum TipoMapaGraficoTabelaQuantis {
	QUANTIS = 'Quantis',
}
export enum AgrupamentoSpi {
	ESTADO_COMPLETO = 'Estado completo',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
}

export enum Agrupamento {
	MUNICIPIO_POSTO = 'Município/Posto',
	MUNICIPIO = 'Município',
	MICRORREGIAO = 'Microrregião',
	MESORREGIAO = 'Mesorregião',
	BACIA = 'Bacia',
	// REGIAO_GEOADMINISTRATIVA = 'Região geoadministrativa',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
	SUBBACIA = 'Sub-bacia',
}
export enum AgrupamentoIAPM {
	MICRORREGIAO = 'Microrregião',
	MESORREGIAO = 'Mesorregião',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
	BACIA_SUBBACIA = 'Bacia/Sub-bacia',
}

export enum AgrupamentoEspecial {
	MUNICIPIO_POSTO = 'Município/Posto',
	MUNICIPIO = 'Município',
	MICRORREGIAO = 'Microrregião',
	MESORREGIAO = 'Mesorregião',
	// REGIAO_GEOADMINISTRATIVA = 'Região geoadministrativa',
	BACIA_SUBBACIA = 'Bacia/Sub-bacia',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
}

export enum AgrupamentoDownloadDadosPluv {
	MUNICIPIO_POSTO = 'Município/Posto',
	MUNICIPIO = 'Município',
	MICRORREGIAO = 'Microrregião',
	MESORREGIAO = 'Mesorregião',
	BACIA_SUBBACIA = 'Bacia/Sub-bacia',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
	REGIONAL = 'Regional',
}

export enum AgrupamentoQuantis {
	MICRORREGIAO = 'Microrregião',
	MUNICIPIO_POSTO = 'Município/Posto',
	REGIAO_PLUVIOMETRICA = 'Região pluviométrica',
}

export enum Meses {
	JANEIRO = 'Janeiro',
	FEVEREIRO = 'Fevereiro',
	MARCO = 'Março',
	ABRIL = 'Abril',
	MAIO = 'Maio',
	JUNHO = 'Junho',
	JULHO = 'Julho',
	AGOSTO = 'Agosto',
	SETEMBRO = 'Setembro',
	OUTUBRO = 'Outubro',
	NOVEMBRO = 'Novembro',
	DEZEMBRO = 'Dezembro',
}
